import { format } from 'date-fns'

import { DATES_FORMAT_FULL_YEAR } from '../../../../../../../constants/dates'
import { getGamInventoryType, inventoryTypes, type InventoryItem } from '../../helpers'

interface DateOverlap {
  existingStart: string
  existingEnd: string
  proposedStart: string
  proposedEnd: string
}

interface LineItem {
  name: string
  [key: string]: any
}

interface Conflict {
  lineItem: LineItem
  conflictingInventoryIds: number[]
  dateOverlap: DateOverlap
}

export const getInventoryDisplayName = (inventoryId: number, allInventory: InventoryItem[] = []): string => {
  const inventoryType = getGamInventoryType(allInventory)

  const confilctedInventoryItem = allInventory.find(inventoryItem => {
    if (inventoryType === inventoryTypes.placements) {
      return inventoryItem.placement_id === inventoryId
    } else {
      return inventoryItem.ad_unit_id === inventoryId
    }
  })

  const fallbackName = inventoryType === inventoryTypes.placements ? 'InventoryItem' : 'Ad Unit'

  return confilctedInventoryItem?.name || `${fallbackName} ${inventoryId}`
}

export const getInventoryNamesDisplay = (inventoryIds: number[], allInventory: InventoryItem[] = []): string => {
  return inventoryIds.map(id => getInventoryDisplayName(id, allInventory)).join(', ')
}

export const generateSingleConflictMessage = (conflict: Conflict, allInventory: InventoryItem[]): string => {
  const { lineItem, conflictingInventoryIds, dateOverlap } = conflict

  const inventoryNames = getInventoryNamesDisplay(conflictingInventoryIds, allInventory)
  const proposedStartFormatted = format(new Date(dateOverlap.proposedStart), DATES_FORMAT_FULL_YEAR)
  const proposedEndFormatted = format(new Date(dateOverlap.proposedEnd), DATES_FORMAT_FULL_YEAR)
  const existingStartFormatted = format(new Date(dateOverlap.existingStart), DATES_FORMAT_FULL_YEAR)
  const existingEndFormatted = format(new Date(dateOverlap.existingEnd), DATES_FORMAT_FULL_YEAR)

  return (
    `Cannot target ${inventoryNames} for dates ${proposedStartFormatted} to ${proposedEndFormatted}. ` +
    `This inventory is already targeted by line item "${lineItem.name}" ` +
    `from ${existingStartFormatted} to ${existingEndFormatted}.`
  )
}

export const generateConflictErrorMessages = (conflicts: Conflict[], allInventory: InventoryItem[] = []): string[] => {
  return conflicts.map(conflict => generateSingleConflictMessage(conflict, allInventory))
}
